// extracted by mini-css-extract-plugin
export default {"container":"Videos_container__dkVj2","videos":"Videos_videos__qhyNT","img":"Videos_img__uWTyq","name":"Videos_name__xMVQb","text":"Videos_text__azI-M"};